import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export function Header({ children, style }: PropsWithChildren & { style?: any }) {
  return (
    <Box
      display="flex"
      padding={'.7rem 8px'}
      bg={'#fff'}
      borderRadius={'16px 16px 0 0'}
      boxShadow={'3px 2px 5px rgba(100,100,100,.1)'}
      justifyContent="space-between"
      title='header-table'
      borderBottom={'1px solid #dbdbdb'}
      {...style}
    >
      {children}
    </Box>
  );
}
